import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'templates'; // Adjust if needed

const scheduleTemplate = async (templateId, jobData, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/${templateId}/schedule`, jobData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to create scheduled job:', error);
        throw error;
    }
  };

export const TemplateSchedulerDataService = {
    scheduleTemplate
};